import _toConsumableArray from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { logger as E } from "../../shared-lib/index.js";
export function getByteLength(t) {
  var e = t.length;
  for (var n = t.length - 1; n >= 0; n--) {
    var r = t.charCodeAt(n);
    r > 127 && r <= 2047 ? e++ : r > 2047 && r <= 65535 && (e += 2), r >= 56320 && r <= 57343 && n--;
  }
  return e;
}
export function decodeBrazeActions(t) {
  try {
    t = t.replace(/-/g, "+").replace(/_/g, "/");
    var e = window.atob(t),
      n = new Uint8Array(e.length);
    for (var _t = 0; _t < e.length; _t++) n[_t] = e.charCodeAt(_t);
    var r = new Uint16Array(n.buffer);
    return String.fromCharCode.apply(String, _toConsumableArray(r));
  } catch (t) {
    return E.error("Unable to decode Base64: " + t), null;
  }
}